module.exports = __webpack_public_path__ + "img/surprise.fba7c254.svg";